import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TramitesComponent } from './tramites/tramites.component';
import { TramiteStartComponent } from './tramites/tramite-start/tramite-start.component';
import { TramiteGuard } from './_guards/tramite.guard';
import { ConsultaGuard } from './_guards/consulta.guard';
import { ReporteGuard } from './_guards/reporte.guard';
import { UserAdministrationGuard } from './_guards/user-administration.guard';
import { TramiteComponent } from './tramites/tramite/tramite.component';
import { TramiteEmpresaComponent } from './tramite-empresa/tramite-empresa.component';
import { ConsultasComponent } from './consultas/consultas.component';
import { CertificadosComponent } from './certificados/certificados.component';
import { LogoutComponent } from './logout/logout.component';
import { LoginComponent } from './login/login.component';
import { ReportesComponent } from './reportes/reportes.component';
import { UserAdministrationComponent } from './user-administration/user-administration.component';
import { VisorTramiteComponent } from './visor-tramite/visor-tramite.component';
import { DetalleComponent } from './detalle/detalle.component';
import { CertificadosmasivosComponent } from './certificadosmasivos/certificadosmasivos.component';

const routes: Routes = [
  { path: '', redirectTo: '/tramites', pathMatch: 'full' },
  {
    path: 'tramites',
    component: TramitesComponent,
    children: [
      {
        path: '',
        component: TramiteStartComponent,
        canActivate: [TramiteGuard],
      },
      { path: ':id', component: TramiteComponent, canActivate: [TramiteGuard] },
    ],
  },
  {
    path: 'consultas',
    component: ConsultasComponent,
    canActivate: [ConsultaGuard],
  },
  {
    path: 'consultas/detalle/:tramite',
    component: DetalleComponent,
    canActivate: [ConsultaGuard],
  },
  {
    path: 'certificados',
    component: CertificadosComponent,
    canActivate: [ConsultaGuard],
  },
  {
    path: 'certificadosmasivos',
    component: CertificadosmasivosComponent,
    canActivate: [ConsultaGuard],
  },
  {
    path: 'visor-tramite/:radicado',
    component: VisorTramiteComponent,
  },
  {
    path: 'reportes',
    component: ReportesComponent,
    canActivate: [ReporteGuard],
  },
  {
    path: 'administracion',
    component: UserAdministrationComponent,
    canActivate: [UserAdministrationGuard],
  },
  { path: 'afiliacion-empresa', component: TramiteEmpresaComponent },
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LogoutComponent },
  { path: '**', redirectTo: '/tramites' },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
